import { getShellLogger } from '../common/logger'

export const SHELL_START_MARK = 'shell start'
export const SHELL_DONE_MARK = 'shell done'

export const getShellLoadingTime = () => {
  try {
    const calculation = performance.measure('Shell Loading Time', SHELL_START_MARK, SHELL_DONE_MARK)
    const loadingTime = calculation?.duration ?? 0

    return loadingTime
  } catch (e) {
    getShellLogger().error('shell - error in the performance calculation for mixpanel', e)
    return 0
  }
}
